import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
	selector: 'button-view',
	templateUrl: './button-view.component.html',
	styles: [],
})
export class ButtonViewComponent implements OnInit {
	@Output() eventClick = new EventEmitter<any>();
	constructor() {}

	ngOnInit(): void {}

	View() {
		this.eventClick.emit();
	}
}
